// Dates Sara has blocked out — no pickup, one-off or subscription. Shared by
// the regular order form (App.jsx) and the subscription signup page. Keep
// this in sync with the server-side copy in api/_lib/time.js (Cron 1 needs
// its own copy since it can't import from src/).
export const BLOCKED_PICKUP_DATES = [
  "2026-06-09",
];
